(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[5],{

/***/ "6lYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ ilab_footer; });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/e6t/lazy-image/index.jsx
var lazy_image = __webpack_require__("eM4/");

// EXTERNAL MODULE: ./__mock__/homeDatas.js
var homeDatas = __webpack_require__("p8IS");

// EXTERNAL MODULE: ./src/components/desktop/common/footer/ilab-footer/styles.module.scss
var styles_module = __webpack_require__("Wubn");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/desktop/common/footer/ilab-footer/ilab-footer.jsx
var __jsx = react_default.a.createElement;





var ilab_footer_IlabFooter = function IlabFooter() {
  var currentDate = new Date();
  var currentYear = currentDate.getFullYear();
  return __jsx("div", {
    className: styles_module_default.a.ilabContainer
  }, __jsx("div", {
    className: styles_module_default.a.ilabWrapper
  }, __jsx("div", {
    className: styles_module_default.a.ilabContent
  }, __jsx("p", {
    className: styles_module_default.a.ilabTitle
  }, "Emlakjet bir "), __jsx("a", {
    className: styles_module_default.a.ilabLogo,
    href: "http://www.ilab.com.tr/",
    target: "_blank",
    rel: "nofollow noreferrer"
  }, __jsx(lazy_image["a" /* default */], {
    src: "/static/img/brands/ilab.png",
    alt: "iLab",
    width: 65,
    height: 23
  })), ' ', __jsx("p", {
    className: styles_module_default.a.ilabTitle
  }, "grup \u015Firketidir")), __jsx("div", {
    className: styles_module_default.a.ilabCompanies
  }, homeDatas["b" /* ilabCompanies */].map(function (company, index) {
    var href = company.href,
        src = company.src,
        width = company.width,
        height = company.height;
    var alt = src === null || src === void 0 ? void 0 : src.slice(19, -4);
    return __jsx("a", {
      href: href,
      target: "_blank",
      rel: "nofollow noreferrer",
      key: index
    }, __jsx(lazy_image["a" /* default */], {
      src: src,
      placeholder: "/static/img/1px-transparent.png",
      alt: "".concat(alt, ".com"),
      width: width,
      height: height
    }));
  })), __jsx("div", {
    className: styles_module_default.a.ilabDetail
  }, "Emlakjet.com \xA9 2006-", currentYear, ' ', "Emlakjet.com sitesinde kullan\u0131c\u0131lar taraf\u0131ndan sa\u011Flanan her t\xFCrl\xFC ilan, bilgi, i\xE7erik ve g\xF6rselin ger\xE7ekli\u011Fi, orijinalli\u011Fi, g\xFCvenilirli\u011Fi ve do\u011Frulu\u011Funa ili\u015Fkin sorumluluk bu i\xE7erikleri giren kullan\u0131c\u0131ya ait olup, emlakjet.com'un bu hususlarla ilgili herhangi bir sorumlulu\u011Fu bulunmamaktad\u0131r.")));
};

/* harmony default export */ var ilab_footer = (ilab_footer_IlabFooter);
// CONCATENATED MODULE: ./src/components/desktop/common/footer/ilab-footer/index.js


/***/ }),

/***/ "Ohjr":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"_2NQFxP","footerContent":"_2Gic0a","footerMain":"_2yjZkG","footerList":"_25fh6R","headerTitle":"_2Vwl4C","footerButton":"_2ejkVv"};

/***/ }),

/***/ "PhnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ footer; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("KQm4");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./src/redux-store/containers/auth/index.js + 11 modules
var auth = __webpack_require__("lDfJ");

// EXTERNAL MODULE: ./services/panelService.js
var panelService = __webpack_require__("D9O2");

// EXTERNAL MODULE: ./src/utils/url/index.js
var utils_url = __webpack_require__("Onhb");

// EXTERNAL MODULE: ./src/helpers/notifier/component/index.jsx
var component = __webpack_require__("bkYj");

// EXTERNAL MODULE: ./src/components/desktop/contracts/index.jsx + 1 modules
var contracts = __webpack_require__("8Xu1");

// EXTERNAL MODULE: ./src/components/desktop/contracts/contents.js + 10 modules
var contents = __webpack_require__("TvSa");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./src/components/e6t/lazy-image/index.jsx
var lazy_image = __webpack_require__("eM4/");

// CONCATENATED MODULE: ./src/components/desktop/common/footer/etbis-logo/index.jsx
var __jsx = react_default.a.createElement;



var etbis_logo_EtbisLogo = function EtbisLogo() {
  return __jsx("div", {
    id: "ETBIS",
    style: {
      marginTop: '8px'
    }
  }, __jsx("div", {
    id: "6300421054042735"
  }, __jsx("a", {
    href: "https://etbis.eticaret.gov.tr/sitedogrulama/6300421054042735",
    target: "_blank",
    rel: "noreferrer"
  }, __jsx(lazy_image["a" /* default */], {
    style: {
      width: '100px',
      height: '120px'
    },
    alt: "etbis-logo",
    src: "data:image/jpeg;base64, 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"
  }))));
};

/* harmony default export */ var etbis_logo = (etbis_logo_EtbisLogo);
// EXTERNAL MODULE: ./src/components/desktop/common/footer/styles.module.scss
var styles_module = __webpack_require__("Ohjr");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/desktop/common/footer/footer.jsx









var footer_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }













var footerListData = [{
  title: 'Emlakjet',
  children: [{
    name: 'Hakkımızda',
    href: '/hakkimizda',
    testSelector: 'footer-about-us'
  }, {
    name: 'Ödüllerimiz',
    href: '/odullerimiz',
    testSelector: 'footer-awards'
  }, {
    name: 'Kurumsal Materyaller',
    href: '/kurumsal-materyaller',
    testSelector: 'footer-corporate-materials'
  }, {
    name: 'Reklam',
    href: '/reklam',
    testSelector: 'footer-advertisement'
  }, {
    name: 'İnsan Kaynakları',
    href: '/insan-kaynaklari',
    testSelector: 'footer-human-resources'
  }, {
    name: 'Site Haritası',
    href: '/site-haritasi',
    testSelector: 'footer-sitemap'
  }, {
    name: 'ETBIS',
    testSelector: 'footer-etbis'
  }]
}, {
  title: 'Hizmetlerimiz',
  children: [{
    name: 'Size Özel Hizmetlerimiz',
    href: '/hizmetler/hizmetlerimiz'
  }, {
    name: 'Emlak Haberleri',
    href: '/haber'
  }, {
    name: 'Kurumsal Üyelik',
    href: '/uye-ol/kurumsal'
  }, {
    name: 'Projeler',
    href: '/satilik-konut/projeler'
  }, {
    name: 'Ücretsiz ilan Ver',
    href: '/'
  } // {
  //   name: 'Jettaşın',
  //   href: '/jettasin/',
  // },
  // İs bankasi comment line
  // {
  //   name: 'Konut Kredisi Hesaplama',
  //   href: '/hizmetlerimiz/isbankasi-konut-kredisi',
  // },
  // {
  //   name: 'Konut Kredisi Hesaplama',
  //   href: '/hizmetlerimiz/akbank-konut-kredisi/',
  // },
  ]
}, {
  title: 'Diğer',
  children: Object.values(contents["a" /* default */])
}];

var footer_Footer = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(Footer, _React$Component);

  var _super = _createSuper(Footer);

  function Footer() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Footer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      selectedContract: null
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "footerListItemRender", function (children) {
      return children.map(function (child, index) {
        if (child.name === 'Ücretsiz ilan Ver') {
          return (// eslint-disable-next-line react/no-array-index-key
            footer_jsx("span", {
              key: child.name + index,
              onClick: _this.handleNewListingLink
            }, child.name)
          );
        }

        if (child.name === 'ETBIS') {
          return (// eslint-disable-next-line react/no-array-index-key
            footer_jsx(etbis_logo, {
              key: child.name + index
            })
          );
        }

        return (// eslint-disable-next-line react/no-array-index-key
          footer_jsx("a", {
            key: child.name + index,
            href: child.href,
            "data-test-selector": child.testSelector
          }, child.name)
        );
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "setContract", function (contract) {
      _this.setState({
        selectedContract: contract.key
      });

      window.history.replaceState('Sözleşmeler ve Koşullar', 'Title', Object(utils_url["a" /* addAnchorToUrl */])(window.location.href, contract.anchor));
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleContractModalClose", function () {
      return _this.setState({
        selectedContract: null
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "contractListItemRender", function (children) {
      return children.map(function (item) {
        var _classnames;

        var isEfilliCookie = item.key === 'cookieManagement';
        var isEfilliCookieClasses = classnames_default()((_classnames = {}, Object(defineProperty["default"])(_classnames, styles_module_default.a.footerButton, !isEfilliCookie), Object(defineProperty["default"])(_classnames, 'efl-edit', isEfilliCookie), _classnames));
        return item.key !== 'employeeCandidateDisclosureEn' && footer_jsx("span", Object(esm_extends["a" /* default */])({}, !isEfilliCookie && {
          onClick: function onClick() {
            return _this.setContract(item);
          }
        }, {
          className: isEfilliCookieClasses,
          key: item.key
        }), item.title);
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleNewListingLink", function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          toggleSignupForm = _this$props.toggleSignupForm,
          isAuth = _this$props.isAuth;

      if (isAuth) {
        panelService["a" /* default */].redirectToPanel();
      } else {
        toggleSignupForm();
      }
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "footerListRender", function () {
      return footerListData.map(function (data) {
        return (// eslint-disable-next-line react/no-array-index-key
          footer_jsx("div", {
            key: data.title,
            className: styles_module_default.a.footerList
          }, footer_jsx("div", {
            className: styles_module_default.a.headerTitle
          }, data.title), data.title === 'Diğer' ? _this.contractListItemRender(data.children) : _this.footerListItemRender(data.children))
        );
      });
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Footer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var url = window.location.href;
      var urlParts = url.split('#');
      var anchorPart = null;

      if (urlParts.length > 1) {
        anchorPart = urlParts[1];
        var selectedContract = Object.values(contents["a" /* default */]).find(function (contract) {
          return contract.anchor === anchorPart;
        });

        if (selectedContract) {
          this.setState({
            selectedContract: selectedContract.key
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var selectedContract = this.state.selectedContract;
      return footer_jsx("div", {
        className: styles_module_default.a.footerContainer
      }, footer_jsx(contracts["a" /* default */], {
        isOpen: !!selectedContract,
        staticContentKey: selectedContract,
        onClose: this.handleContractModalClose
      }), footer_jsx("div", {
        className: styles_module_default.a.footerContent
      }, footer_jsx("div", {
        className: styles_module_default.a.footerMain
      }, this.footerListRender(), footer_jsx("div", {
        className: styles_module_default.a.footerList,
        style: {
          justifyContent: 'space-between'
        }
      }, footer_jsx("div", {
        className: styles_module_default.a.headerTitle
      }, "\u0130leti\u015Fim"), footer_jsx(desktop_elements["b" /* Button */], {
        secondary: true,
        style: {
          width: 280,
          margin: '8px 0 20px 0'
        }
      }, "0 850 312 73 73"), footer_jsx(desktop_elements["b" /* Button */], {
        secondary: true,
        style: {
          width: 280,
          marginBottom: 20
        },
        onClick: function onClick() {
          return window.location = '/iletisim';
        }
      }, "Mesaj G\xF6nder"), footer_jsx(desktop_elements["b" /* Button */], {
        secondary: true,
        style: {
          width: 280
        },
        onClick: function onClick() {
          return window.location = '/iletisim';
        }
      }, "\u0130leti\u015Fim Bilgileri")))), footer_jsx(component["a" /* default */], null));
    }
  }]);

  return Footer;
}(react_default.a.Component);

/* harmony default export */ var footer = (es["b" /* connect */].apply(void 0, Object(toConsumableArray["a" /* default */])(auth["a" /* default */]))(footer_Footer));
// CONCATENATED MODULE: ./src/components/desktop/common/footer/index.js


/***/ }),

/***/ "Wubn":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"ilabContainer":"_36tTcF","ilabWrapper":"_2U4D2M","ilabTitle":"_3ckJLF","ilabCompanies":"_2ZZafB","ilabDetail":"RjdATo","ilabContent":"_1USRnK","ilabLogo":"_3YphmV"};

/***/ }),

/***/ "p8IS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return socialBarIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return socialBarApps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ilabCompanies; });
var featuredNewItems = [{
  slug: 'istanbul',
  img: '/static/img/content/city_istanbul.jpg',
  title: 'İstanbul',
  count: '120.000'
}, {
  slug: 'izmir',
  img: '/static/img/content/city_izmir.jpg',
  title: 'İzmir',
  count: '30.000'
}, {
  slug: 'ankara',
  img: '/static/img/content/city_ankara.jpg',
  title: 'Ankara',
  count: '40.000'
}, {
  slug: 'antalya',
  img: '/static/img/content/city_antalya.jpg',
  title: 'Antalya',
  count: '25.000'
}, {
  slug: 'aydin',
  img: '/static/img/content/city_aydin.jpg',
  title: 'Aydın',
  count: '20.000'
}, {
  slug: 'bursa',
  img: '/static/img/content/city_bursa.jpg',
  title: 'Bursa',
  count: '8.000'
}];
var socialBarIcons = [{
  href: 'https://www.facebook.com/Emlakjetcom/',
  src: '/static/icons/social/Facebook.svg',
  placeholder: '/static/img/1px-transparent.png'
}, {
  href: 'https://x.com/emlakjet',
  src: '/static/icons/social/Twitter.svg',
  placeholder: '/static/img/1px-transparent.png'
}, {
  href: 'https://www.instagram.com/emlakjet/',
  src: '/static/icons/social/Instagram.svg',
  placeholder: '/static/img/1px-transparent.png'
}, {
  href: 'https://tr.pinterest.com/emlakjet/',
  src: '/static/icons/social/Pinterest.svg',
  placeholder: '/static/img/1px-transparent.png'
}, {
  href: 'https://www.linkedin.com/company/emlakjet-com',
  src: '/static/icons/social/LinkedIn.svg',
  placeholder: '/static/img/1px-transparent.png'
}];
var socialBarApps = [{
  href: 'https://apps.apple.com/tr/app/emlakjet-emlak-ara-i-lan-ver/id1194656334?l=tr',
  src: '/static/icons/social/AppStore.svg',
  placeholder: '/static/img/1px-transparent.png',
  isSvgIcon: true
}, {
  href: 'https://play.google.com/store/apps/details?id=com.emlakjet.kurumsal.sekizbit',
  src: '/static/icons/social/GooglePlay.svg',
  placeholder: '/static/img/1px-transparent.png',
  isSvgIcon: true
}, {
  href: 'https://appgallery.huawei.com/app/C101850135',
  src: '/static/icons/social/AppGallery.svg',
  placeholder: '/static/img/1px-transparent.png',
  isSvgIcon: true
}];
var ilabCompanies = [{
  href: 'https://www.kariyer.net/',
  src: '/static/img/brands/kariyer.png',
  width: 85,
  height: 18
}, {
  href: 'https://www.sigortam.net/',
  src: '/static/img/brands/sigortam.png',
  width: 100,
  height: 18
}, {
  href: 'https://www.arabam.com/',
  src: '/static/img/brands/arabam.png',
  width: 80,
  height: 13
}, {
  href: 'https://www.hangikredi.com/',
  src: '/static/img/brands/hangikredi.png',
  width: 90,
  height: 16
}, {
  href: 'https://www.cimri.com/',
  src: '/static/img/brands/cimri.png',
  width: 40,
  height: 14
}, {
  href: 'https://www.neredekal.com/',
  src: '/static/img/brands/neredekal.png',
  width: 110,
  height: 14
}, {
  href: 'https://tr.steelorbis.com/',
  src: '/static/img/brands/steelorbis.png',
  width: 62,
  height: 27
}, {
  href: 'https://www.chemorbis.com/tr/',
  src: '/static/img/brands/chemorbis.png',
  width: 68,
  height: 27
}, {
  href: 'https://www.endeksa.com/tr/',
  src: '/static/img/brands/endeksa.png',
  width: 85,
  height: 21
}];
/* harmony default export */ __webpack_exports__["a"] = (featuredNewItems);

/***/ })

}]);